import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "picker" }
const _hoisted_2 = { class: "picker-list" }
const _hoisted_3 = ["type", "checked", "onChange"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "picker-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.term) = $event)),
      type: "search",
      class: "picker-search",
      placeholder: "Search staff by name"
    }, null, 512), [
      [_vModelText, _ctx.term]
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtered, (user) => {
        return (_openBlock(), _createElementBlock("label", {
          key: user.id,
          class: _normalizeClass(["picker-row", { selected: _ctx.isSelected(user.id) }])
        }, [
          _createElementVNode("input", {
            type: _ctx.multiple ? 'checkbox' : 'radio',
            checked: _ctx.isSelected(user.id),
            onChange: ($event: any) => (_ctx.toggle(user.id))
          }, null, 40, _hoisted_3),
          _createElementVNode("span", null, [
            _createElementVNode("b", null, _toDisplayString(user.name), 1),
            (user.designation)
              ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(user.designation), 1))
              : _createCommentVNode("", true)
          ])
        ], 2))
      }), 128)),
      (!_ctx.filtered.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "No match."))
        : _createCommentVNode("", true)
    ])
  ]))
}